// Human-readable error messages mapped from backend error codes.
// Used by RequestReset.
export const ERROR_MESSAGES = {
  network_error: 'Something went wrong. Please try again.',
  captcha: 'Please complete the reCAPTCHA and try again.',
  'email is required': 'Please enter your email address.',
  token_expired: 'This link expired. Please request a new password reset.',
  invalid_password: 'Password too short or invalid. Please choose a stronger password.',
  invalid_token: 'This reset link is invalid or already used. Please request a new one.',
  inactive_user: 'Your account is inactive. Please contact support.',
};

export function errorMessage(code) {
  return ERROR_MESSAGES[code] || `An error occurred: ${code}`;
}
